import { event } from '../../Foundation';

export class Accessory {
    /**
    * Factory for methods, properties and events relating to accessory-control
    * @param {HTMLElement} element Element
    */
    constructor (element) {
        // Name, reference
        element.Accessory = this;

        this._refs = {
            el: element,
            filters: Array.from(element.querySelectorAll('.configurator__accessories-filters select')),
            items: Array.from(element.querySelectorAll('.configurator__accessories-item'))
        };

        // Filtering
        if(this._refs.filters != null) {
            this._refs.filters.forEach(x => x.addEventListener('change', this._onFilterChange.bind(this)));
        }

        // Warranty
        if(this._refs.items != null) {
            this._addExtendedWarranty();
        }

        this._onSideSelectionLoad();
    }

    /**
     * Highlight only selectable items based on earside selection (accessories)
     **/
    _onSideSelectionLoad () {
        const oComponent = document.querySelector('.configurator__side-selection');

        if (oComponent === null) return false;

        let oSelectedSideOption = oComponent.querySelector('.is-side-selection input:checked');

        if (oSelectedSideOption === null) return false;

        // selected filter value
        const sideFilterValue = oSelectedSideOption.value.toLowerCase();

        const getAttribute = (elem) => {
            return elem.getAttribute('data-filter-sideproperty') || elem.getAttribute('data-filter-side') || elem.getAttribute('data-filter-tubeside');
        }
        // Filter current items based on sideselection
        let attributeLength = this._refs.items.filter(x => getAttribute(x)).length;
        const arrFilteredItems = this._refs.items.filter(x => {
            let attribute = getAttribute(x); 
            if(attribute !== null) {
                attribute = attribute.toLowerCase();
                return attribute !== sideFilterValue;
            };
        });

        this._onSideSelectionToggl(arrFilteredItems, arrFilteredItems.length !== attributeLength);
    }

    /**
    * Toggl items/checkboxes on/off
    * TODO: rewamp classList.add/remove due to support of IE11
    * @param {Array} items - List of items to iterate
    * @param {Boolean} disabled - State of items
    * @param {String} eventtype - typeof event used as trigger
    **/
    _onSideSelectionToggl(items = [], disabled = false) {
        if (!items.length) return;

        items.forEach(x => {
            // Item class state
            if (disabled) { 
                x.classList.add('is-disabled');
            } else {
                x.classList.remove('is-disabled');
            }

            // Only reset checkboxes, in case user makes active change
            const oCheckbox = x.querySelector('input[type="checkbox"]');
            if (oCheckbox !== null) {
                if (disabled) { // IE 11 
                    oCheckbox.removeAttribute('checked');
                    oCheckbox.checked = false;
                    oCheckbox.disabled = true;
                }
            }

            // If item has numberInput
            const oNumberInput = x.querySelector('.number-input');
            if (oNumberInput !== null) {
                const
                    oButtons = Array.from(oNumberInput.querySelectorAll('button')),
                    oInput = oNumberInput.querySelector('input[type="text"]');

                oButtons.forEach(x => {
                    if (disabled) {
                        x.classList.add('is-disabled');
                    } else {
                        x.classList.remove('is-disabled');
                    }
                    
                    x.disabled = disabled;
                });
                
                /**
                 *  Reset number of items when switching between left and right side
                 */ 
                if (disabled) {
                    // !Set timeout is need to change the value
                    // An investigation is needed (300ms is random)
                    setTimeout(() => {
                        oInput.value = 0;
                    }, 300)
                }

                oInput.disabled = disabled;
            }
        });
    }

    /**
     * addExtendedWarranty 
     * @description Add validation for extended warranty
     * @type Private
     */
    _addExtendedWarranty () {
        this._refs.items.forEach(x => {
            const
                hasWarranty = x.querySelector('.configurator__accessory-warranty'),
                oQuantity = x.querySelector('.number-input__field'),
                oCheckbox = x.querySelector('input[type="checkbox"]'),
                oWarranty = x.querySelector('.form-select select'),
                handler = (e) => {
                    const options = Array.from(oWarranty.options);
                    if((oQuantity != null && e.target.value > 0) || (oCheckbox != null && oCheckbox.checked)) {
                        if(oWarranty) {
                            oWarranty.classList.remove('is-disabled');
                        }
                    } else {
                        // Reset select
                        oWarranty.selectedIndex = 0;

                        // Reset options
                        options.forEach(x => x.removeAttribute('selected'));
                        options[0].setAttribute('selected','');

                        event.emit(oWarranty, 'refresh');
                        if(oWarranty) {
                            oWarranty.classList.add('is-disabled');
                        }
                    }
                    event.emit(oWarranty, 'reflow');
                };

            if(!hasWarranty) return false;

            if(oQuantity != null) {
                oQuantity.addEventListener('change', handler);
            }

            if(oCheckbox != null) {
                oCheckbox.addEventListener('change', handler);
            }
        });
    }

    /**
     * onFilterChange
     * @description Listener for handling changes to filter-elements
     * @type Private
     * @param {Event} e - Event interface
     */
    _onFilterChange () {
        let arrFilters = [];

        this._refs.filters.forEach(item => {
            const selectedIndex = item.selectedIndex;
            if(item.dataset.filtername !== item.options[selectedIndex].value.trim()) {
                arrFilters.push([item.dataset.filtername, item.options[selectedIndex].value.trim()]);
            }
        });

        this._applyItemFiltering(arrFilters);
    }

    /**
     * ApplyItemFiltering
     * @description Apply a filtering on all element items
     * @type Private
     * @param {Array} arrFilters - Filters to apply to items
     */
    _applyItemFiltering(arrFilters = []) {
        this._refs.items.forEach(item => {
            item.classList.remove('is-hidden');
            for(let i = 0; i < arrFilters.length; i++) {
                let filter = arrFilters[i],
                    attr = item.getAttribute(`data-filter-${filter[0]}`);

                if ((attr !== null && typeof attr !== 'undefined') && attr != filter[1]) {
                    item.classList.add('is-hidden');
                }
            }
        });
    }
}